interface MapGISToolsProps {
  onMeasureDistance: () => void;
  onMeasureArea: () => void;
  onDrawPolygon: () => void;
  onSelectArea: () => void;
  onMyLocation: () => void;
  onToggleClusters: () => void;
  clustersEnabled: boolean;
}

const tools = [
  { id: "distance", label: "Medir distância", icon: "ri-ruler-line", action: "onMeasureDistance" },
  { id: "area", label: "Medir área", icon: "ri-shape-line", action: "onMeasureArea" },
  { id: "polygon", label: "Desenhar polígono", icon: "ri-pencil-ruler-line", action: "onDrawPolygon" },
  { id: "select", label: "Selecionar por área", icon: "ri-checkbox-multiple-blank-line", action: "onSelectArea" },
  { id: "location", label: "Minha localização", icon: "ri-user-location-line", action: "onMyLocation" },
];

export default function MapGISTools({
  onMeasureDistance,
  onMeasureArea,
  onDrawPolygon,
  onSelectArea,
  onMyLocation,
  onToggleClusters,
  clustersEnabled,
}: MapGISToolsProps) {
  const actionMap: Record<string, () => void> = {
    onMeasureDistance,
    onMeasureArea,
    onDrawPolygon,
    onSelectArea,
    onMyLocation,
  };

  return (
    <div className="flex flex-col gap-1.5">
      {tools.map((tool) => (
        <button
          key={tool.id}
          onClick={actionMap[tool.action]}
          className="w-10 h-10 bg-white/95 backdrop-blur-sm border border-background-200/70 rounded-lg flex items-center justify-center hover:bg-background-50 transition-colors shadow-sm group relative"
          title={tool.label}
        >
          <i className={`${tool.icon} text-foreground-600 text-base`} aria-hidden="true"></i>
          {/* Tooltip */}
          <span className="absolute left-full ml-2 px-2 py-1 bg-foreground-900 text-white text-[10px] rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
            {tool.label}
          </span>
        </button>
      ))}

      <div className="w-full h-px bg-background-200/70 my-1"></div>

      {/* Clusters toggle */}
      <button
        onClick={onToggleClusters}
        className={`w-10 h-10 border rounded-lg flex items-center justify-center transition-colors shadow-sm group relative ${
          clustersEnabled
            ? "bg-accent-50 border-accent-300 text-accent-600"
            : "bg-white/95 backdrop-blur-sm border-background-200/70 text-foreground-600 hover:bg-background-50"
        }`}
        title="Agrupar pontos (clusters)"
      >
        <i className={`ri-bubble-chart-line text-base`} aria-hidden="true"></i>
        <span className="absolute left-full ml-2 px-2 py-1 bg-foreground-900 text-white text-[10px] rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
          {clustersEnabled ? "Clusters ativos" : "Ativar clusters"}
        </span>
      </button>
    </div>
  );
}